angular.module('unica_invitation_group.invitation_group_services')

.factory('InvitationGroupCreateService', function($http, getBaseApiURL) {

	var InvitationGroupCreateService = {};

	InvitationGroupCreateService.create = function( eventId, invitationGroupData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-group/create/' + eventId,
			data: invitationGroupData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitationGroup;
			}

		});
	};

	return InvitationGroupCreateService;

});